const pageId = '25091';

export default {
  pageName: 'Real-time Streaming',
  pageId,
  pagePath: '/opinion/Realtime/RealtimeStreaming',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    Search: {
      buttonId: `${pageId}001`,
    },
    Download: {
      buttonId: `${pageId}002`,
    },
    SortBy: {
      buttonId: `${pageId}003`,
    },
    GotoDetail: {
      buttonId: `${pageId}004`,
    },
    VisitSourceSite: {
      buttonId: `${pageId}005`,
    },
    FilterTime: {
      buttonId: `${pageId}006`,
    },
    FilterStreamer: {
      buttonId: `${pageId}007`,
    },
    FilterStatus: {
      buttonId: `${pageId}008`,
    },
  },
};
